import * as React from 'react';

import {FormUserAssignments} from '../../forms';

import {StageItemSidebar} from './sidebar/stage-item-sidebar';

type OwnProps = {
    entityId: string | null | undefined;
    parentId: string;
};

type Props = OwnProps;

export class UserAssignmentEditor extends React.PureComponent<Props> {
    sidebarFormSubmitBtnRef: HTMLInputElement | null | undefined;

    render() {
        return (
            <StageItemSidebar
                onSave={this.handleSidebarFormSave}
                parentId={this.props.parentId}
                title='Stage assignee'
            >
                <FormUserAssignments
                    // @ts-expect-error
                    formSubmitBtnRef={(node) => {
                        this.sidebarFormSubmitBtnRef = node;
                    }}
                    {...this.props}
                />
            </StageItemSidebar>
        );
    }

    handleSidebarFormSave = () => {
        if (this.sidebarFormSubmitBtnRef) {
            this.sidebarFormSubmitBtnRef.click();
        }
    };
}
